module.exports = __webpack_public_path__ + "img/code_img.d3e7fab7.jpg";